/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const WarehouseCreditBucketDTOPackageStatusEnum = {
    NotPurchased: 'NOT_PURCHASED',
    SubmittedToWh: 'SUBMITTED_TO_WH',
    GoingToWh: 'GOING_TO_WH',
    AtWh: 'AT_WH',
    AtWhPaymentPending: 'AT_WH_PAYMENT_PENDING',
    AtWhReturnLabelPending: 'AT_WH_RETURN_LABEL_PENDING',
    Returned: 'RETURNED',
    Shipped: 'SHIPPED',
    Delivered: 'DELIVERED',
    Disposed: 'DISPOSED'
};
/**
 * Check if a given object implements the WarehouseCreditBucketDTO interface.
 */
export function instanceOfWarehouseCreditBucketDTO(value) {
    return true;
}
export function WarehouseCreditBucketDTOFromJSON(json) {
    return WarehouseCreditBucketDTOFromJSONTyped(json, false);
}
export function WarehouseCreditBucketDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'packageStatus': json['packageStatus'] == null ? undefined : json['packageStatus'],
        'payable': json['payable'] == null ? undefined : json['payable'],
        'count': json['count'] == null ? undefined : json['count'],
        'costUsd': json['costUsd'] == null ? undefined : json['costUsd'],
        'unknownCostCount': json['unknownCostCount'] == null ? undefined : json['unknownCostCount'],
    };
}
export function WarehouseCreditBucketDTOToJSON(json) {
    return WarehouseCreditBucketDTOToJSONTyped(json, false);
}
export function WarehouseCreditBucketDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'packageStatus': value['packageStatus'],
        'payable': value['payable'],
        'count': value['count'],
        'costUsd': value['costUsd'],
        'unknownCostCount': value['unknownCostCount'],
    };
}
